export default {
  "0001": "An error occurred when trying to authenticate, please try again.",
  "0002": "The selected external account is linked to a different email than the one entered on the login page.",
  "0003": "Your account is inactive. Please contact your administrator.",
  "0004": "Your account does not exist. Please contact your administrator.",
  "0005": "You must consent to the requested authorizations to use the application.",
  "0006": "Your account is not registered with Omega Point. The administrator of your domain has been emailed to review your account creation.",
  "0007": "Please initiate email verification process on your external identity provider prior to linking it to this account.",
  "0008": "The email of your external identity provider must match the email used to log in to Omega Point.",
  "0009": "Your account is inactive. Check your email to complete activation or contact your account administrator to receive another activation link by email.",
} as const
